var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 65h2v-6h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 66c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M8 69h29v-2H8zM43 69h29v-2H43z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 10c-13.63 0-22 3.494-22 6s8.37 6 22 6 22-3.494 22-6-8.37-6-22-6zm0 14c-11.635 0-24-2.804-24-8s12.365-8 24-8 24 2.804 24 8-12.365 8-24 8z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 36c-11.635 0-24-2.804-24-8v-7h2v7c0 2.506 8.37 6 22 6s22-3.494 22-6v-7h2v7c0 5.196-12.365 8-24 8",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 48c-11.635 0-24-2.804-24-8v-7h2v7c0 2.506 8.37 6 22 6s22-3.494 22-6v-7h2v7c0 5.196-12.365 8-24 8",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 60c-11.635 0-24-2.804-24-8v-7h2v7c0 2.506 8.37 6 22 6s22-3.494 22-6v-7h2v7c0 5.196-12.365 8-24 8",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 54h2v-2h-2zM35 54h2v-2h-2zM43 54h2v-2h-2zM39 42h2v-2h-2zM35 42h2v-2h-2zM43 42h2v-2h-2zM39 30h2v-2h-2zM35 30h2v-2h-2zM43 30h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }))));
}

export default SvgIconIllustrationDatabase;